import React, { useEffect, useState } from 'react'
import {
  useParams,
  useHistory,
  withRouter,
  useLocation,
} from 'react-router-dom'
import { Form } from 'react-bootstrap'
import { routes } from '../../../../constantes/routes'
import { useDispatch, useSelector } from 'react-redux'
import { swalTitle } from '../../../../constantes/swalTitle'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../../utils/swalAlert'
import { specialtiesActions } from '../../../../actions/specialtiesActions'
import { departamentsActions } from '../../../../actions/departamentsActions'
import { timeSlotsActions } from '../../../../actions/timeSlotsActions'
import { positionsActions } from '../../../../actions/positionsActions'
import AddHospitalToContactForm from './AddHospitalToContactForm'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import Header from '../../../header/Header'
import '../../../../assests/styles/contatcs/deleteInputFormBtn.scss'
import { swalMssgs } from '../../../../constantes/swalMssgs'
import { hospitalsContactsActions } from '../../../../actions/hospitalsContactsActions'
import validators from '../../../../utils/validationsRegEx'
import FooterLGPD from '../../../common/FooterLGPD'

const AddHospitalToContactContainer = () => {
  const { id } = useParams()
  const history = useHistory()

  const location = useLocation()

  const departaments = useSelector((state) => state.departaments)
  const positions = useSelector((state) => state.positions)
  const specialties = useSelector((state) => state.specialties)
  const timeSlots = useSelector((state) => state.timeSlots)
  const contacts = useSelector((state) => state.contacts)

  const [isDisable, setIsDisable] = useState(false)
  const [nameCoontact, setNameContact] = useState('')

  const [inputs, setinputs] = useState({
    id_Contacto: id,
    id_TipoDepartamento: '',
    id_TipoEspecialidad: '',
    id_TipoCargo: '',
    id_Hospital: '',
    id_TipoFranjaHoraria: '',
  })

  const dispatch = useDispatch()
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties(0))
  const getAllDepartaments = () =>
    dispatch(departamentsActions.getAllDepartaments())
  const getTimeSlots = () => dispatch(timeSlotsActions.getAllTimeSlots())
  const getPositions = () => dispatch(positionsActions.getAllPositions())
  const newContact = (contact) =>
    dispatch(hospitalsContactsActions.newHospitalContact(contact))
  const deleteContact = (id_Contacto) =>
    dispatch(hospitalsContactsActions.deleteContactHospitals(id_Contacto))

  useEffect(() => {
    getContactById(id)
  }, [id])

  useEffect(() => {
    getAllSpecialties()
    getAllDepartaments()
    getTimeSlots()
    getPositions()
  }, [])

  const getContactById = async (idContact) => {
    try {
      const response = contacts.find(
        (x) => x.id_Contacto.toString() === idContact.toString(),
      )
      if (response) setNameContact(response.nombre)
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  // Submit para crear un contacto hospital
  const handleSubmitToCreateContactHospital = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      await newContact(inputs)
      swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
      history.push(routes.CONTACTS)
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  const handleSubmitToCreateContactHospitalToPresentation = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      await newContact(inputs)
      swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
      history.push(routes.PRESENTATION)
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  const handleRemoveContactToGoBack = async (event, id) => {
    event.preventDefault()
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quires salir? Se eliminará toda la información del contacto hasta ahora',
      )
      if (alert.isConfirmed) {
        deleteContact(id)
        await history.push(routes.CONTACTS)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const handleChangeSelect = (event, idSelected) => {
    const value = event.value
    setinputs((inputs) => ({ ...inputs, [idSelected]: '' + value }))
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs?.id_TipoDepartamento) &&
      //   validators.hasValue(inputs.id_TipoEspecialidad) &&
      validators.hasValue(inputs?.id_Hospital) &&
      validators.hasValue(inputs?.id_TipoCargo)
    )
  }

  return (
    <>
      {
        <div className='products'>
          {
            // Se utiliza location en el state para que cuando hagamos click al CloseBtn, me haga una función u otra
            location.state ? ( //vengo de editar
              <Header
                text={'Añadir hospital al contacto ' + `${nameCoontact}`}
                route={() => history.goBack()}
                backBtn={false}
              />
            ) : (
              //vengo de crear
              <Header
                text={'Añadir hospital al contacto ' + `${nameCoontact}`}
                route={(event) => handleRemoveContactToGoBack(event, id)}
                backBtn={false}
              />
            )
          }
          <div className='task__container'>
            <Form>
              <div className='row col-12 form__container'>
                <AddHospitalToContactForm
                  handleChange={handleChange}
                  inputs={inputs}
                  handleChangeSelect={handleChangeSelect}
                  departaments={departaments}
                  positions={positions}
                  specialties={specialties}
                  timeSlots={timeSlots}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  width: '40%',
                  margin: '20px auto 0 auto',
                }}
              >
                {location.state ? ( // vengo de editar
                  <>
                    <button
                      onClick={(e) => handleSubmitToCreateContactHospital(e)}
                      disabled={isDisable || !validateForm()}
                      className='btn save'
                    >
                      {onSubmitText.Crear}
                    </button>
                  </>
                ) : (
                  // vengo de crear
                  <>
                    <button
                      onClick={(e) => handleSubmitToCreateContactHospital(e)}
                      disabled={isDisable || !validateForm()}
                      className='btn save'
                    >
                      {onSubmitText.Crear}
                    </button>
                    <button
                      onClick={(e) =>
                        handleSubmitToCreateContactHospitalToPresentation(e)
                      }
                      disabled={isDisable || !validateForm()}
                      className='btn save'
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          lineHeight: '20px',
                        }}
                      >
                        {onSubmitText.Crear}
                        <span>+</span>
                        <span style={{ fontSize: '12px', fontWeight: '600' }}>
                          presentación
                        </span>
                      </div>
                    </button>
                  </>
                )}
              </div>
            </Form>
          </div>
        </div>
      }
    </>
  )
}

export default withRouter(AddHospitalToContactContainer)
